import {UserManager, WebStorageStateStore} from 'oidc-client-ts'
import type {KeycloakConfig} from './types'

/**
 * Create the Keycloak UserManager after the caller has selected Keycloak.
 */
export function createKeycloakUserManager(nuxtApp: any): UserManager {
  const config = nuxtApp.$config.public.keycloak as KeycloakConfig
  if (!config?.authority) {
    throw new Error('Keycloak authority is not configured')
  }

  const host = nuxtApp.$config.public.BASE_URL

  return new UserManager({
    authority: config.authority,
    client_id: config.clientId,
    redirect_uri: host + '/auth',
    response_type: 'code',
    scope: config.scope,
    automaticSilentRenew: false,
    userStore: new WebStorageStateStore({
      prefix: 'ENuxtKeycloakUser.',
      store: globalThis.localStorage
    }),
    stateStore: new WebStorageStateStore({
      prefix: 'ENuxtKeycloakState.',
      store: globalThis.localStorage
    })
  })
}
